export const environment = {
    production: true,
    calculator: {
        clientCode: 'qantas',
        clientId: '5e81337781651c156cc578c1',
        apiKey: '41affd5c-7b7c-41d3-9551-987891cafc2e',
        clientCalculator: 'retbenefit',
        soAUrl: 'soa',
        faqUrl: 'faq'
    },
    calculators: [
        {
            pageTitleSuffix: 'Retirement Benefit - Qantas',
            clientCalculator: 'retbenefit',
            clientCode: 'qantas',
            clientId: '5e81337781651c156cc578c1',
            apiKey: '41affd5c-7b7c-41d3-9551-987891cafc2e'
        }
    ],
    appInsights: {
        instrumentationKey: '1e0c864c-8bee-40ab-8959-97bfadd242d4',
        enableDebug: true
    },
    switches: {
        // useDummyContent: false, //for testing static JSON content
        // useDummyInit: false, //for using dummy init data
        // isTestingToolVisible: false
        useDummyContent: false,
        useDummyInit: false, //for using dummy init data
        useDummyResults: false, //for unit testing of ApiService and ContentsService
        isTestingToolVisible: false,
        withCredentials: true,
        showPrintPreview: false,
        isWidget: false,
        apiDataFormat: 'json'
    },
    urls: {
        base: 'https://apps-au.willistowerswatson.com/qantas/api', //'https://apps-au.willistowerswatson.com/qantas/api',//'https://hcbtas-p-calc-qantas-api.azurewebsites.net',
        // init: '/app/{0}/{1}', // {0} = clientCode, {1} = clientcalculator
        init: '/app', // {0} = clientCode, {1} = clientcalculator
        initAfterLogin: '/app', // {0} = clientCode, {1} = clientcalculator
        // calc: '/clients/{0}/projection', // {0} = clientCode
        calc: '/projection', // {0} = clientCode
        content: "https://cloud90.towerswatson.com/api/content/qantas/retbenefit/en-us",

         //PDF SOA URLS - local development target the local PdfController. dev/uat/prod environments target Azure Cloud Service.
        host: window.location.origin,
        pdfServiceGenerate: 'https://apps.willistowerswatson.com/pdf/GeneratePdfPost', //window.location.origin + '/api/pdf/generate',
        pdfServiceGetPdfModel: 'https://apps.willistowerswatson.com/pdf/GetPDFModel',
        pdfServiceSetPdfModel: 'https://apps.willistowerswatson.com/pdf/SetPDFModel',

        login: '/login',
        logout: '/auth/logout?continue=/',
        resetPassword: 'NOT_USED_IN_THIS_APP'
    }
};
